var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperuser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Empty State / Superuser-New") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.78494476,16.9428005 C7.78494476,16.9428005 24.5652232,22.2918594 48.0615949,14.2665079 C71.5579666,6.24115646 120.223097,25.8567234 120.223097,25.8567234 C120.223097,25.8567234 158.820724,25.8567234 215.880971,0 C215.880971,0 189.869382,26.7488209 208.328684,42.7995238 C226.787986,58.8502268 210.007707,82.0306576 188.190359,90.9481066 C166.37301,99.8655556 164.697305,117.696927 166.37301,134.639728 C168.048716,151.582528 166.37301,135.531825 166.37301,135.531825 C166.37301,135.531825 100.924284,123.049512 84.1406868,165.856088 L1.07216974,26.7523469 C1.07216974,26.7523469 -3.96158198,16.054229 7.78494476,16.9428005 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78494476,16.9428005 C7.78494476,16.9428005 24.5652232,22.2918594 48.0615949,14.2665079 C71.5579666,6.24115646 120.223097,25.8567234 120.223097,25.8567234 C120.223097,25.8567234 158.820724,25.8567234 215.880971,0 C215.880971,0 189.869382,26.7488209 208.328684,42.7995238 C226.787986,58.8502268 210.007707,82.0306576 188.190359,90.9481066 C166.37301,99.8655556 164.697305,117.696927 166.37301,134.639728 C168.048716,151.582528 166.37301,135.531825 166.37301,135.531825 C166.37301,135.531825 100.924284,123.049512 84.1406868,165.856088 L1.07216974,26.7523469 C1.07216974,26.7523469 -3.96158198,16.054229 7.78494476,16.9428005 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Empty-State-/-Superuser-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_super_woman_dv0y",
    transform: "translate(30.251548, 25.176319)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 161.93775,
    cy: 295.63485,
    rx: 93.9058494,
    ry: 15.1621315
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.937956,241.962618 C223.694414,243.027465 226.78315,242.126031 228.641121,239.714483 C230.499093,237.302934 230.720974,233.907364 229.194481,231.246087 C227.667988,228.58481 224.726136,227.2384 221.857636,227.8882 L222.030493,231.665405 L220.348768,228.428304 C218.698249,229.252413 217.423151,230.739145 216.803683,232.561786 C216.583686,233.200235 216.449944,233.868592 216.406448,234.546922 C216.188323,237.816996 218.03806,240.844042 220.937956,241.962618 L220.937956,241.962618 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.259189,285.771809 C228.665541,282.559458 231.237951,279.711611 233.778904,277.86052 C236.319857,276.009428 239.288821,274.190653 240.155791,271.049253 C241.401786,266.53451 237.690348,262.399856 234.801618,258.834305 C232.658456,256.18826 230.817984,253.28161 229.318715,250.17518 C228.717757,248.929593 228.165438,247.627494 228.007278,246.23787 C227.779515,244.236659 228.384541,242.245265 228.994089,240.33637 C231.024676,233.977283 233.19573,227.671476 235.507249,221.418949",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.222368,240.990147 C223.978826,242.054995 227.067562,241.15356 228.925533,238.742012 C230.783505,236.330463 231.005386,232.934893 229.478893,230.273616 C227.9524,227.612339 225.010548,226.265929 222.142048,226.915729 L222.314904,230.692934 L220.633177,227.455836 C218.982658,228.279945 217.707561,229.766675 217.088092,231.589315 C216.868097,232.227764 216.734357,232.896121 216.69086,233.574451 C216.472735,236.844525 218.322472,239.871571 221.222368,240.990147 Z",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.415098,220.114523 C229.216754,217.764057 231.090486,216.009857 233.38578,215.460937 L233.954398,219.051816 L235.008599,215.28044 C238.011949,215.32777 240.642019,217.432773 241.514035,220.48713 C242.386051,223.541487 241.29997,226.844524 238.827632,228.657137 C236.355295,230.46975 233.063858,230.376123 230.686318,228.425552 C228.308779,226.474982 227.390547,223.114931 228.415088,220.114523 L228.415098,220.114523 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.794315,218.817896 C229.595968,216.467428 231.469701,214.713227 233.764997,214.16431 L234.333612,217.755189 L235.387813,213.983813 C238.391163,214.031142 241.021235,216.136144 241.893251,219.190501 C242.765268,222.244858 241.679188,225.547896 239.206851,227.36051 C236.734513,229.173123 233.443076,229.079497 231.065536,227.128926 C228.687996,225.178356 227.769764,221.818304 228.794305,218.817896 L228.794315,218.817896 Z",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58934,258.907083 C236.889535,260.179182 240.562683,258.617542 242.1264,255.277549 C243.690117,251.937556 242.646646,247.882386 239.701184,245.852601 L238.891135,248.750775 L238.31673,245.117569 C238.31105,245.114724 238.30517,245.112356 238.299143,245.110485 C235.979473,244.21463 233.386219,244.702443 231.496914,246.390041 C229.60761,248.07764 228.709523,250.708425 229.14119,253.290717 C229.572857,255.873008 231.268643,258.014169 233.589317,258.907083 L233.58934,258.907083 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.917931,257.593718 C237.218126,258.865817 240.891274,257.304177 242.454991,253.964184 C244.018708,250.624191 242.975237,246.569021 240.029775,244.539236 L239.219726,247.43741 L238.645341,243.804204 C238.639661,243.801359 238.633781,243.79899 238.627754,243.79712 C236.307996,242.900884 233.714464,243.388515 231.824937,245.07617 C229.93541,246.763826 229.037241,249.394855 229.469045,251.977342 C229.900849,254.559828 231.59696,256.701037 233.917931,257.593718 Z",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.399762,271.094129 C226.964668,274.509905 229.703769,277.038395 232.965609,277.155126 C236.227448,277.271857 239.120428,274.944921 239.900315,271.577271 C240.680202,268.209622 239.133821,264.721781 236.193513,263.216634 C233.253205,261.711487 229.722683,262.600455 227.730564,265.347561 L230.807448,270.268745 L226.603273,267.656736 C226.277294,268.768668 226.207499,269.947551 226.399762,271.094129 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.684174,270.121662 C227.249084,273.537435 229.988186,276.065922 233.250025,276.18265 C236.511864,276.299379 239.404841,273.972441 240.184726,270.604792 C240.964612,267.237143 239.41823,263.749304 236.477923,262.244158 C233.537616,260.739011 230.007095,261.627978 228.014976,264.375084 L231.091856,269.296267 L226.887681,266.684259 C226.561704,267.796194 226.49191,268.97508 226.684174,270.121662 L226.684174,270.121662 Z",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.616839,92.8549023 C231.156408,81.8991515 239.673211,73.3099611 249.997257,73.3097476 C250.587085,73.3097476 251.169521,73.3424379 251.745947,73.3971944 C256.359583,64.9627815 264.845538,59.771291 274.026242,59.7666754 C283.206946,59.7620659 291.697517,64.9450271 296.318657,73.3748002 C296.804953,73.3359887 297.294524,73.3097618 297.790155,73.3097618 C308.114201,73.3099752 316.631004,81.8991656 317.170573,92.8549023",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.658954,91.2684955 C235.198526,80.3127461 243.715328,71.7235577 254.039373,71.7233444 C254.629201,71.7233444 255.211637,71.7560311 255.788063,71.8107911 C260.401699,63.3763782 268.887654,58.1848877 278.068358,58.1802721 C287.249062,58.1756626 295.739633,63.3586238 300.360773,71.788397 C300.847069,71.7495855 301.336637,71.7233585 301.832271,71.7233585 C312.156316,71.7235718 320.673118,80.3127603 321.212689,91.2684955",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,183.827691 C0.539569838,172.871941 9.05637257,164.28275 19.3804186,164.282537 C19.9702469,164.282537 20.5526822,164.315227 21.1291247,164.369983 C25.7427612,155.935571 34.2287159,150.74408 43.4094201,150.739464 C52.5901242,150.734855 61.0806949,155.917816 65.7018348,164.347589 C66.188131,164.308778 66.6777024,164.282551 67.1733328,164.282551 C77.4973788,164.282764 86.0141815,172.871955 86.5537514,183.827691",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0421159,182.241285 C4.58168744,171.285535 13.0984897,162.696347 23.4225345,162.696134 C24.0123628,162.696134 24.5947981,162.72882 25.171224,162.78358 C29.7848605,154.349167 38.2708152,149.157677 47.4515194,149.153061 C56.6322235,149.148452 65.1227942,154.331413 69.7439341,162.761186 C70.2302303,162.722375 70.7197983,162.696148 71.2154321,162.696148 C81.5394769,162.696361 90.0562792,171.285549 90.5958507,182.241285",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.15934,34.6746302 C129.698909,23.7188794 138.215712,15.129689 148.539758,15.1294755 C149.129587,15.1294755 149.712022,15.1621658 150.288464,15.2169223 C154.902101,6.78250935 163.388056,1.59101887 172.56876,1.58640324 C181.749464,1.58179377 190.240035,6.76475494 194.861174,15.1945281 C195.347471,15.1557166 195.837042,15.1294896 196.332672,15.1294896 C206.656718,15.1297031 215.173521,23.7188935 215.713091,34.6746302",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.201456,33.0882234 C133.741027,22.132474 142.257829,13.5432856 152.581874,13.5430723 C153.171702,13.5430723 153.754138,13.575759 154.330564,13.630519 C158.9442,5.1961061 167.430155,0.00461562381 176.610859,0 C185.791563,-0.00460947158 194.282134,5.1783517 198.903274,13.6081249 C199.38957,13.5693134 199.879138,13.5430864 200.374772,13.5430864 C210.698817,13.5432997 219.215619,22.1324881 219.75519,33.0882234",
    id: "Path",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boy",
    transform: "translate(59.564586, 45.447003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4360991,116.576224 L22.376371,116.576224 L19.5591955,112.71517 L14.9999503,117.56 L15.504321,118.363946 L14.9302676,118.512041 C14.9302676,118.512041 24.1317135,137.39771 25.6647348,130.229195 C27.1977561,123.06068 22.4360991,116.576224 22.4360991,116.576224 Z",
    id: "Path",
    fill: "#FDB797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(33.860376, 32.154887)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2F94FB",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    mask: "url(#mask-2)",
    points: "-33.795769 -9.30884354 175.13645 150.29551 187.722489 111.064376"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(82.568643, 57.542642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c8ed4358-d450-436c-89b2-67b880a93208"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.504036, -34.696599)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12.5860384 49.9327778 128.378919 174.762959 145.162516 161.388549"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.1,
    transform: "translate(34.421538, 31.950374)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0717131,29.7318821 C12.0717131,29.7318821 28.8519915,35.080941 52.3483632,27.0555896 C75.844735,19.0302381 124.503229,38.6493311 124.503229,38.6493311 C124.503229,38.6493311 155.727753,38.6493311 203.523508,19.8341837 C207.302969,9.21363946 215.963544,0.306768707 215.963544,0.306768707 C158.890024,26.1634921 120.305671,26.1634921 120.305671,26.1634921 C120.305671,26.1634921 71.637222,6.54792517 48.1441685,14.5732766 C24.651115,22.5986281 7.86751834,17.2495692 7.86751834,17.2495692 C-3.87900841,16.3574717 1.15474331,27.0591156 1.15474331,27.0591156 L4.60901854,32.8454082 C5.329074,30.8954875 7.33660187,29.3722222 12.0717131,29.7318821 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.421212,43.1062925 C207.558916,42.3604309 206.753401,41.5433668 206.012179,40.6627211 C205.819722,45.9271542 207.528609,51.1633787 212.615452,55.5886054 C213.97112,56.7540942 215.213878,58.0605225 216.325231,59.4884467 C216.487824,53.7691497 214.15511,48.0921655 208.421212,43.1062925 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDB797",
    fillRule: "nonzero",
    points: "72.1099706 240.260431 70.5636764 248.479717 64.3751814 248.479717 65.9247938 236.974127"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "71.983878 241.395828 71.5491901 242.785102 65.446969 240.933912 65.8816569 240.006553"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDB797",
    fillRule: "nonzero",
    points: "31.9030032 240.260431 33.4492974 248.479717 39.6344742 248.479717 38.08818 236.974127"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "31.8797756 241.395828 32.3144635 243.247018 38.4200028 240.933912 38.4200028 240.006553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2003797,16.6084127 C85.2003797,16.6084127 85.0278318,8.37149658 79.5826198,3.83696144 C74.1374079,-0.697573712 78.2121917,20.1239115 78.2121917,20.1239115 L85.2003797,16.6084127 Z",
    id: "Path",
    fill: "#FDB797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6344742,246.836565 L31.9030032,246.836565 L30.356709,251.773073 C30.356709,251.773073 22.4526902,251.589717 22.625238,253.416224 C22.7977859,255.242732 27.0915728,258.352732 38.08818,255.059376 L41.1807684,251.773073 C41.1807684,251.773073 42.7270626,250.122868 39.6344742,246.836565 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3751814,246.836565 L72.1066524,246.836565 L73.6529466,251.773073 C73.6529466,251.773073 81.5569654,251.589717 81.3844176,253.416224 C81.2118697,255.242732 76.9180828,258.352732 65.9214756,255.059376 L62.8288872,251.773073 C62.8288872,251.773073 61.282593,250.122868 64.3751814,246.836565 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6463101,135.091655 L30.356709,135.091655 C16.2675134,174.530828 17.9863555,192.609025 17.9863555,192.609025 L30.356709,241.907109 L39.6477471,240.263957 L30.356709,190.976451 C38.08818,184.220488 52.008146,158.109887 52.008146,158.109887 C52.008146,158.109887 65.9214756,184.206383 73.6463101,190.976451 L64.355272,240.274535 L73.6463101,241.917687 L86.0166637,192.619603 C86.0166637,192.619603 87.7454605,174.530828 73.6463101,135.091655 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.356709,135.729875 C30.356709,135.729875 54.9115955,145.602891 73.6562648,135.729875 L30.356709,135.729875 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9895991,76.0933333 L16.6192456,89.2385487 L21.2647646,115.532506 L15.0795878,120.469014 L4.25552843,85.959297 C4.25552843,85.959297 0.990392183,79.5700453 5.80182263,76.0862812 L24.3606712,56.364932 C24.3606712,56.364932 32.3244182,50.695 37.7994942,53.6004875 C43.2745702,56.505975 28.8834159,75.8852948 28.8834159,75.8852948",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8070966,75.9311338 L30.3533908,135.091655 C30.3533908,135.091655 54.9082772,144.964671 73.6529466,135.091655 L72.1066524,79.4007936 L71.7117833,77.5601814 L71.9971509,76.6539796 L90.5792271,60.2788775 C95.6727069,57.2993424 92.9816241,50.6139002 92.9816241,50.6139002 L85.2169708,15.1874036 L78.623652,19.4821655 L80.9464115,46.1181519 L67.7133187,57.782415 L67.3814959,57.7647846 L67.3814959,57.8529365 L33.4592521,56.2133106",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FDB797",
    fillRule: "nonzero",
    x: 45.9059249,
    y: 48.0857029,
    width: 12.3703536,
    height: 14.7883673,
    rx: 6.18517679
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3007941,54.400907 C50.278254,55.8768887 54.6708634,55.3582491 58.2464145,52.9904762 C57.3540262,50.3946081 55.0336142,48.6649173 52.4328792,48.6569274 L52.4328792,48.6569274 C49.3231401,48.668249 46.701552,51.1239142 46.3007941,54.400907 L46.3007941,54.400907 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 50.5448075,
    cy: 39.8699433,
    rx: 13.9166478,
    ry: 14.7883673
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2586243,43.2635822 C54.1587156,42.3973676 53.8889603,41.5592454 53.4647367,40.796996 C53.0120147,40.013755 52.1023611,39.6143091 51.2178851,39.8103616 C49.8997322,40.2214593 49.4578513,42.2545242 48.0797823,42.3217947 C47.1510837,42.3666418 46.4845177,41.4248543 46.192427,40.5428629 C45.9003363,39.6608715 45.7430566,38.6518135 45.0465326,38.0314297 C44.5615724,37.6695348 44.0050161,37.4147451 43.4138204,37.2839794 C40.2158016,36.2749214 36.9129297,34.4137701 35.84942,31.2371061 C35.5991859,30.5922195 35.5394058,29.8892653 35.6771613,29.2115156 C36.1639792,27.2008742 38.6729635,26.5954394 40.5827874,25.8704126 C42.4926113,25.1453857 44.3275401,23.9046182 46.1999165,22.9628307 C48.0722928,22.0210433 50.2442494,21.3558125 52.3038634,21.8341807 C53.3489753,22.1622201 54.376407,22.5439286 55.3820501,22.9777797 C58.4827054,24.0541082 62.2798847,23.5533165 64.6840159,25.788193 C65.7345076,26.8967635 66.5047876,28.2394908 66.9308675,29.7048329 C68.6085168,34.353974 69.6720265,39.8701576 66.89342,43.9512365 C65.1783233,46.4701442 63.5156531,49.347828 60.2202707,49.6542826 C56.3856439,49.9756863 54.8652743,46.5075167 54.2586243,43.2635822 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 52.2762785,
    cy: 40.8699433,
    rx: 1.5462942,
    ry: 3.28630385
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "28.827006 75.9240816 32.7524696 77.8775283 28.827006 82.9762358"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "71.983878 76.6434013 69.3691144 79.7322449 71.111184 82.5107936 72.12988 79.4219501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2736043,61.5694218 L52.2736043,64.2457143 C52.2736043,64.2457143 33.9072129,60.6808503 33.4393428,55.3282653 L45.5608292,56.2203628 L52.2736043,61.5694218 Z",
    id: "Path",
    fill: "#2F94FB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2736043,61.5694218 L52.2736043,64.2457143 C52.2736043,64.2457143 70.6399957,60.6808503 71.1078658,55.3282653 L58.9863793,56.2203628 L52.2736043,61.5694218 Z",
    id: "Path",
    fill: "#2F94FB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "164.525936 90.6101927 224.940911 105.768798 203.123563 115.578345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4957526,55.4587301 C33.4957526,55.4587301 33.4957526,49.8557936 37.0130742,49.8557936 C40.5303958,49.8557936 44.0443991,61.0651927 44.0443991,61.0651927 L33.4957526,55.4587301 Z",
    id: "Path",
    fill: "#2F94FB",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperuser);
export default __webpack_public_path__ + "static/media/superuser.baf11df5009e48595749c8ab14cfe917.svg";
export { ForwardRef as ReactComponent };